import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isResearchStaff } from "config/constants";
import { routes } from "config/routes";
import * as signInSelectors from "store/selectors/signIn";

interface IResearchOnlyProps {
  children: JSX.Element;
}

export const ResearchOnly = ({ children }: IResearchOnlyProps) => {
  const userInfo = useSelector(signInSelectors.userInfo);

  if (!userInfo.id) return null;

  return isResearchStaff(
    userInfo.roles,
    userInfo.researchStaffLevel,
    userInfo.researchStaffEligible
  ) ? (
    children
  ) : (
    <Navigate to={routes.private.properties} replace />
  );
};
